export default __webpack_public_path__ + "static/media/image.2a4e535a.jpg";